export class VerificationDocRemoveCommand{
    caseId:string;
    documentId:string;

    constructor(caseId:string, documentId:string){
        this.caseId = caseId;
        this.documentId = documentId;
    }
}